import Carousel from 'react-multi-carousel';
import { useEffect, useState } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import BenefitCard from './BenefitCard';
import { useTranslation } from 'react-i18next';
import APIEndpoints from '../../../../api/APIEndpoints';
import { axiosInstance } from '../../../../../api/axios';
import Skeleton from './skeleton/GenericSkeleton';
import CustomClientError from '../../../../errorhandling/CustomClientError';

import '../index.scss';
const useCoverageCarousel = () => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1250 },
      items: 3,
    },
    desktop1: {
      breakpoint: { max: 1250, min: 1024 },
      items: 2,
    },
    desktop2: {
      breakpoint: { max: 1024, min: 900 },
      items: 2,
    },
    desktop3: {
      breakpoint: { max: 900, min: 800 },
      items: 2,
    },
    desktop4: {
      breakpoint: { max: 800, min: 576 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 576, min: 0 },
      items: 1,
    },
  };

  return {
    responsive,
  };
};
export const BenefitsAvailed = ({
  activeOID,
  benefitYear,
  yearORNetworkFilter,
  startEndDate,
}) => {
  const { responsive } = useCoverageCarousel();
  const { t } = useTranslation();

  const [benefitsAvailedData, setBenefitsAvailedData] = useState([]);
  const [skeletonLoader, setSkeletonLoader] = useState(true);
  const [isNotFound, setIsNotFound] = useState(false);
  const [isAPIFailed, setIsAPIFailed] = useState(false);

  const fetchBenefitsAvailed = async (benefitYear, activeOID) => {
    setIsNotFound(false);
    setIsAPIFailed(false);
    try {
      const benefitsAvailedDetails = await axiosInstance.get(
        APIEndpoints.getBenefitsAvailed() +
          '/oid/' +
          activeOID +
          '/planstartdate/' +
          startEndDate?.startDate +
          '/planenddate/' +
          startEndDate?.endDate,
      );
      setBenefitsAvailedData(
        benefitsAvailedDetails?.data?.Response?.Disability,
      );
      setSkeletonLoader(false);
    } catch (e) {
      setSkeletonLoader(false);
      if (e.toString().includes('404')) {
        setIsNotFound(true);
      }
      setIsAPIFailed(true);
    }
  };
  useEffect(() => {
    if (yearORNetworkFilter.includes('benefitYear-')) {
      const selectedYear = yearORNetworkFilter.split('benefitYear-')[1];
      if (selectedYear === benefitYear) {
        setSkeletonLoader(true);
        fetchBenefitsAvailed(benefitYear, activeOID);
      }
    } else {
      setSkeletonLoader(true);
      fetchBenefitsAvailed(benefitYear, activeOID);
    }
  }, [benefitYear, activeOID]);

  return skeletonLoader ? (
    <Skeleton />
  ) : isAPIFailed ? (
    <div className="px-0">
      {isNotFound ? null : (
        <CustomClientError
          ErrorHeading="Something went wrong with request!"
          ErrorMessage="Server request failed. Please contact support team."
          CustomClasses="p-0"
        />
      )}
    </div>
  ) : (
    <>
      {benefitsAvailedData.length !== 0 && (
        <Card className="benefits-availed">
          <Row>
            <Col className="">
              <h4>{t('member.pages.coverages.coverage_benefits_availed')}</h4>
            </Col>
          </Row>
          <Row>
            <Col className="">
              <div className="carousel-container p-0">
                <div className="carousel-wrapper">
                  {benefitsAvailedData.length !== 0 && (
                    <Carousel
                      additionalTransfrom={0}
                      arrows
                      shouldResetAutoplay={false}
                      centerMode={false}
                      className=""
                      containerClass="container-with-dots"
                      dotListClass=""
                      draggable
                      focusOnSelect={false}
                      infinite={false}
                      keyBoardControl
                      minimumTouchDrag={80}
                      renderButtonGroupOutside={false}
                      renderDotsOutside={false}
                      itemClass="slider-image-item"
                      responsive={responsive}
                    >
                      {benefitsAvailedData.map((data, index) => (
                        <BenefitCard
                          key={index}
                          Data={data}
                          skeletonLoader={skeletonLoader}
                        />
                      ))}
                    </Carousel>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Card>
      )}
    </>
  );
};
